"use client";
import { hometestimonials, testimonials } from "@/data/testimonials";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
export default function AttendanceTrackingSmainFeatures() {
  return (
    <div className="container position-relative">
      <div className="pt-80 pb-80 pt-sm-70 pb-sm-70 px-4 bg-gray-light-1">
        <div className="row">
          <div className="col-lg-12 -offset-lg-1 wow fadeInUp">
            <div className="row">
              <div className="col-md-10 offset-md-1 text-center">
                <h2 className="section-title mb-70 mb-sm-40">
                  {/* GetBiz Solutions is trusted by &nbsp;
                  <span className="mark-decoration-1">10,000+</span>
                  &nbsp;customers. */}
                  Advanced AI-Powered Tools for Smarter Hiring Decisions
                </h2>

              </div>
            </div>
            <div className="overflow-hidden">
              <Swiper
                rewind
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".snbp2",
                  nextEl: ".snbn2",
                }}
                watchSlidesProgress
                resizeObserver
                style={{
                  opacity: 1,
                  display: "block",
                }}
                className="testimonials-slider-1 owl-carousel owl-theme pb-xs-80 overflow-visible position-static"
              >
                {/* {hometestimonials.map((testimonial, index) => (
                  <SwiperSlide className="owl-item" key={index}>
                    <div>
                      <blockquote className="mb-0">
                        <div className="blockquote-icon" aria-hidden="true">
                          ”
                        </div>
                        <p>{testimonial.quote}</p>
                        <div className="section-line mt-40" />
                        <footer className="ts1-author mt-20 clearfix">
                          <div className="overflow-hidden">
                            {testimonial.author}
                            <div className="small">{testimonial.role}</div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                  </SwiperSlide>
                ))} */}
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/recruitmentms/candidate-communication.webp"
                          className="image-fullwidth relative"
                          alt="candidate-communication"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/recruitment-management-systems/candidate-communication" >
                            <h3 className="h3">Automated Candidate Screening with AI</h3>
                          </Link>
                          <p className="text-gray">
                            Utilize AI to evaluate candidates based on predefined criteria, ensuring a faster and more objective hiring process.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Criteria-based screening
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                AI talent matching
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Candidate ranking
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Automated evaluation
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/recruitmentms/reporting-and-analytics.webp"
                          className="image-fullwidth relative"
                          alt="reporting-and-analytics"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/recruitment-management-systems/reporting-and-analytics" >
                            <h3 className="h3">Comprehensive Reporting Tools</h3>
                          </Link>

                          <p className="text-gray">
                            Gain actionable insights through customizable reports and real-time analytics to optimize your recruitment strategy.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                KPI tracking
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Time-to-hire analysis
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Source tracking
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Custom reports
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={1200}
                          height={700}
                          src="/assets/images/img/product/hrms/recruitmentms/interview-management.webp"
                          className="image-fullwidth relative"
                          alt="interview-management"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/recruitment-management-systems/interview-management" >
                            <h3 className="h3">Efficient Interview Scheduling</h3>
                          </Link>

                          <p className="text-gray">
                            Automate the interview scheduling process, reducing administrative tasks and ensuring better coordination between candidates and interviewers.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Automated scheduling
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Panel coordination
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Reminder notifications
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className="!text-sm">
                                Time zone sync
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>


                <div className="owl-controls clickable">
                  {/* <div className="owl-pagination">
                    <div className="owl-page">
                      <span className=""></span>
                    </div>
                    <div className="owl-page active">
                      <span className=""></span>
                    </div>
                  </div> */}
                  {/* owl-buttons */}
                  <div className=" text-center">
                    <div className="owl-prev snbp2" role="button" tabIndex="0">
                      <span className="visually-hidden">Previous Slide</span>
                      <i className="mi-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="owl-next snbn2" role="button" tabIndex="0">
                      <span className="visually-hidden">Next Slide</span>
                      <i className="mi-arrow-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                {/* End Slide Item */}
              </Swiper>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
